import { isoTimestamp } from 'ProdantixSdk/core/time';
import type { Clock, EventContext, EventEnvelope, EventProperties, IdFactory } from 'ProdantixSdk/core/types';
import { assertDistinctId, assertEventName } from 'ProdantixSdk/core/validation';

export interface BuildEnvelopeInput {
  context?: EventContext;
  distinctId: string;
  eventId?: string;
  eventName: string;
  properties?: EventProperties;
  sessionId?: string;
  timestamp?: Date;
}

export function buildEnvelope(input: BuildEnvelopeInput, clock: Clock, ids: IdFactory): EventEnvelope {
  assertEventName(input.eventName);
  assertDistinctId(input.distinctId);
  const envelope: EventEnvelope = {
    distinct_id: input.distinctId,
    event_id: input.eventId ?? ids.uuid(),
    event_name: input.eventName,
    properties: input.properties ?? {},
    schema_version: 1,
    timestamp: isoTimestamp(input.timestamp ?? clock.now()),
  };
  if (input.context) {
    envelope.context = input.context;
  }
  if (input.sessionId) {
    envelope.session_id = input.sessionId;
  }
  return envelope;
}
